/* eslint-disable max-len */
import React, {useState, useRef} from 'react';
import {SafeAreaView} from 'react-native-safe-area-context';
import {useSelector} from 'react-redux';
import {StyleSheet, Text, View, TouchableOpacity, Alert} from 'react-native';
import FastImage from '../../../Utils/FastImage';

////////////////////////////
// Utils ///////////////////
const {barChallengeCompletionEvent} = require('src/Utils/huntFunctions');
import isIphoneX from 'src/Utils/IphoneXHelper';
import helpers from 'src/Utils/helpers';
const {ordinalSuffixOf} = helpers;

////////////////////////////
// Components //////////////
import {
  PrimaryButton,
  SecondaryButton,
  FooterOverlay,
  HeaderText,
  BodyText,
  BarChallengeHeader,
} from 'src/Modules/CommonView';
import ModalSelector from 'react-native-modal-selector';
import {navigationRef} from 'src/Nav/navigationHelpers';
import useParams from '../../../Hooks/useParams';
import {useUserId} from 'src/Hooks/reduxHooks';

const BarChallengeCompletionModal = () => {
  console.log('BarChallengeCompletionModal render');

  const {subChallengeId} = useParams();

  const userId = useUserId();
  const subChallenges =
    useSelector((state) => state.game_v2?.subChallenges) || {};
  const groupInfo = useSelector((state) => state.groupInfo);

  const [selectedPlace, setSelectedPlace] = useState(0);

  const selectorRef = useRef();

  const winnerList = (selectedBarChallenge, playerCount, playerList) => {
    const {challengeMedium, completionRank = []} = selectedBarChallenge;

    var maxCompletions = groupInfo?.isCoOp
      ? 1
      : challengeMedium == 'tournament'
      ? 3
      : 6;

    //already sorted by completionTime, first completed to last, sliced for maxpossible
    const completedChallenges = completionRank.filter(
      (completion) => completion?.completeTime,
    );
    const challengeFinished =
      completedChallenges?.length >= maxCompletions ? true : false;
    // eslint-disable-next-line no-use-before-define
    const winnerIcons = profileWinnerIcons(completedChallenges); //limit this
    let addChallengerIcon;

    if (!challengeFinished) {
      const iconParams = {
        completionRank,
        challengeFinished,
        playerList,
        challengeMedium,
        selectedBarChallenge,
        completedChallenges,
      };

      // eslint-disable-next-line no-use-before-define
      addChallengerIcon = challengerIcon(iconParams);
    }

    return (
      // eslint-disable-next-line no-use-before-define
      <View style={styles.winnerContainer}>
        {winnerIcons}
        {addChallengerIcon}
      </View>
    );
  };

  const profileWinnerIcons = (winnerArray) => {
    return winnerArray?.map?.((winner, index) => (
      <View key={`winners${index}`}>
        <TouchableOpacity
          onPress={() => {
            setSelectedPlace(index);
            winner.challengeMedium == 'photo' ||
            winner.challengeMedium == 'video'
              ? null
              : selectorRef.current.open();
          }}
          // eslint-disable-next-line no-use-before-define
          style={styles.winnerIconWrapper}
          key={`bh_completion_${index}`}>
          <FastImage
            source={require('src/Images/foxIcon.png')}
            style={{position: 'absolute', top: -7.5, width: 67, height: 67}}
            resizeMode={FastImage?.resizeMode?.contain}
          />
          <FastImage
            source={{uri: winner.thumbnail || winner.photoUrl}}
            style={{
              width: 74,
              height: 74,
              borderRadius: 37,
              borderWidth: 3,
              borderColor: global?.color?.orange,
            }}
            resizeMode={FastImage?.resizeMode?.cover}
          />
          <Text
            style={{
              marginTop: 2,
              marginBottom: 0,
              height: 20,
              color: global?.color?.gray3,
              fontFamily: global?.font.gothic,
              fontSize: 16,
            }}>
            {winner.firstName || ''}
            {!groupInfo?.isCoOp
              ? `(${ordinalSuffixOf(index + 1).toUpperCase()})`
              : ''}
          </Text>
          <Text
            style={{
              marginTop: 0,
              height: 20,
              color: global?.color?.gray3,
              fontFamily: global?.font.circular,
              fontSize: 10,
            }}>
            {winner.pointValue} POINTS
          </Text>
        </TouchableOpacity>
      </View>
    ));
  };

  const challengerIcon = (iconParams) => {
    const {
      challengeFinished,
      challengeMedium,
      completedChallenges,
      selectedBarChallenge,
    } = iconParams;
    const isPhotoOrVideo =
      challengeMedium == 'photo' || challengeMedium == 'video';
    const index = completedChallenges?.length;
    const points = selectedBarChallenge.pointsRemaining;

    return (
      <TouchableOpacity
        onPress={() => {
          setSelectedPlace(index);
          if (isPhotoOrVideo && challengeFinished) {
            Alert.alert(
              'You have already completed this challenge.',
              'Other bar hunters can still compete this challenge for points. Try completing other challenges!',
            );
          } else {
            selectorRef.current.open();
          }
        }}
        // eslint-disable-next-line no-use-before-define
        style={styles.winnerOpacity}
        key={`bh_completion_${index}`}>
        <FastImage
          source={require('src/Images/addPlayerButton.png')}
          style={{width: 78, height: 76}}
          resizeMode={FastImage?.resizeMode?.cover}
        />
        <Text
          style={{
            marginTop: 2,
            marginBottom: 0,
            height: 20,
            color: global?.color?.gray3,
            fontFamily: global?.font.gothic,
            fontSize: 16,
          }}>
          {challengeMedium == 'photo' || challengeMedium == 'video'
            ? `TAKE ${challengeMedium.toUpperCase()}`
            : groupInfo?.isCoOp
            ? 'Complete Challenge'
            : ('SELECT ' + ordinalSuffixOf(index + 1)).toUpperCase()}
        </Text>
        <Text
          style={{
            marginTop: 0,
            height: 20,
            color: global?.color?.gray3,
            fontFamily: global?.font.circular,
            fontSize: 10,
          }}>
          {points} POINTS
        </Text>
      </TouchableOpacity>
    );
  };

  const openCameraToChallenge = ({
    selectedChallenge = {},
    completionParams = {},
  }) => {
    navigationRef.navigate('PhotoVideoCamera', {
      shareUUID: selectedChallenge.shareUUID,
      text: completionParams.firstName + ': ' + selectedChallenge.question,
      photoUrl: selectedChallenge.photoUrl,
      isVideo: selectedChallenge.challengeMedium == 'video',
      onCapture: (data) => {
        const params = {
          ...selectedChallenge,
          groupId: groupInfo?.groupId,
          ...data,
          ...completionParams,
        };
        barChallengeCompletionEvent(params, groupInfo);
      },
      onReport: () => {
        navigationRef.navigate('QuestionFeedback', {
          challenge: {...selectedChallenge, theme: 'standard'},
          type: 'Bar',
        });
      },
    });
  };
  const handleModalSelection = (
    selectedChallenge,
    userId,
    parentUserId,
    name,
    photoUrl,
  ) => {
    const completionParams = {
      userId,
      parentUserId,
      groupId: groupInfo?.groupId,
      challengeId: selectedChallenge.challengeId,
      photoUrl,
      photoColor: groupInfo?.players[userId]
        ? groupInfo?.players[userId].photoColor
        : '#e87722',
      firstName: name || '',
      ...selectedChallenge,
    };

    console.log({completionParams});

    // Alert.alert('', JSON.stringify(completionParams))

    if (
      selectedChallenge.challengeMedium != 'photo' &&
      selectedChallenge.challengeMedium != 'video'
    ) {
      barChallengeCompletionEvent(completionParams, groupInfo);
    } else {
      openCameraToChallenge({
        selectedChallenge,
        completionParams,
      });
    }
  };

  const beginChallenge = (playerCount, challengeMedium, playerList) => {
    const index = playerCount - 1;

    setSelectedPlace(index);
    //Checking to see if it is a photo challenge how many players are left for a completion, and doing the right action for a photo challenge
    if (
      (challengeMedium == 'photo' || challengeMedium == 'video') &&
      playerList &&
      playerList?.length == 0
    ) {
      Alert.alert(
        'You have already completed this challenge.',
        'Other bar hunters can still compete this challenge for points. Try completing other challenges!',
      );
    } else if (
      (challengeMedium == 'photo' || challengeMedium == 'video') &&
      playerList &&
      playerList?.length == 2
    ) {
      console.log('done');
    } else {
      selectorRef.current.open();
    }
  };

  const selectedBarChallenge =
    subChallenges && subChallenges[subChallengeId]
      ? subChallenges[subChallengeId]
      : null;

  console.log({selectedBarChallenge});

  if (!selectedBarChallenge) {
    console.warn('No selectedBarChallenge', {subChallengeId, subChallenges});
    navigationRef.goBack(null);
  }

  const {name, challengeMedium, question, completionRank} =
    selectedBarChallenge;

  const headerTitle =
    challengeMedium == 'completion'
      ? 'COMPLETION CHALLENGE'
      : challengeMedium == 'tournament'
      ? 'PLAYER TOURNAMENT'
      : challengeMedium == 'video'
      ? 'Video Challenge'
      : 'PHOTO CHALLENGE!';
  const bodyTitle =
    challengeMedium == 'completion'
      ? 'Task: '
      : challengeMedium == 'tournament'
      ? 'Game Rules: '
      : 'Task: ';

  let finishedPlayers = [];

  if (completionRank) {
    Object.values(completionRank || {})?.map?.((completion) => {
      completion.userId && finishedPlayers.push(completion.userId);
    });
  }

  let playerCount = 0;
  let playerList;
  const typePhotoOrVideo =
    challengeMedium == 'photo' || challengeMedium == 'video';
  //players added to by playerList.map below
  //players is the list passed to ModalSelector, which renders options(players) for users to select
  let players = [
    {
      key: 0,
      section: true,
      label: typePhotoOrVideo
        ? `WHICH MEMBER OF YOUR TEAM IS DOING THE ${challengeMedium.toUpperCase()} CHALLENGE`
        : groupInfo
        ? `Select Who Finished The Challenge`
        : `SELECT ${ordinalSuffixOf(
            selectedPlace + 1,
          )?.toUpperCase?.()} PLACE WINNER`,
    },
  ];

  if (groupInfo?.players) {
    playerList = Object.values(groupInfo?.players);
    playerCount = playerList?.length;
    playerList = playerList
      .filter((player) => {
        const hasNotFinishedChallenge = !finishedPlayers?.includes?.(
          player.userId,
        );
        return hasNotFinishedChallenge;
      })
      .sort((a, b) => {
        const rankA =
          1 * (a?.userId == userId) + 0.5 * (a?.parentUserId == userId);
        const rankB =
          1 * (b?.userId == userId) + 0.5 * (b?.parentUserId == userId);
        return rankB - rankA;
      });

    playerList?.map?.((player, index) => {
      players.push({
        key: index + 1,
        label: player.firstName,
        userId: player.userId,
        parentUserId: player.parentUserId,
        photoUrl: player.photoUrl,
      });
    });
  }

  function jsUcfirst(string = '  ') {
    return string?.charAt(0)?.toUpperCase?.() + string?.slice(1);
  }

  var maxCompletions = groupInfo?.isCoOp
    ? 1
    : challengeMedium == 'tournament'
    ? 3
    : 6;

  const challengeComplete =
    finishedPlayers?.length === maxCompletions ||
    finishedPlayers?.length === playerCount;

  return (
    // eslint-disable-next-line no-use-before-define
    <SafeAreaView style={{...styles.container}}>
      <View
        style={{
          alignItems: 'center',
          position: 'relative',
          marginTop: isIphoneX() ? 40 : 0,
        }}>
        <BarChallengeHeader
          handleCancel={() => navigationRef.goBack(null)}
          title={
            headerTitle.toUpperCase() + (challengeComplete ? ' Finished' : '')
          }
          height={85}
          challengeMedium={'title'}
        />
        <HeaderText text={name.toUpperCase()} />
        <BodyText text={bodyTitle + question} textStyle={{textAlign: 'left'}} />
        {!groupInfo?.isCoOp && <HeaderText text={'WINNER LIST'} />}

        {winnerList(
          selectedBarChallenge,
          playerCount,
          players,
          challengeComplete,
        )}
      </View>

      {/* footer controls */}
      <FooterOverlay>
        <SecondaryButton
          handlePress={() => {
            navigationRef.navigate('WhatIsThis', {
              headerText: `${jsUcfirst(challengeMedium).replace(
                'Completion',
                'Dare',
              )} Bar Challenge`,
              bodyText: [
                challengeMedium != 'completion'
                  ? 'Race with your fellow hunters to be the first to complete this challenge at the bar. You get more points for being the first person to finish a challenge. '
                  : 'Play this game with your fellow hunters as a tournament. After the tournament is finsihed assign first, second, and third place.',
                `This 'BAR' challenge should be completed at this bar. When you are done with the majority of the  challenges you can move onto the next bar!`,
                'Throughout the hunt you will also be sent individual player challenges, which you can finish at any bar.',
              ],
            });
          }}
          text={'WHAT IS THIS?'}
          textStyle={{fontSize: 12}}
          background={global?.color?.blue}
          icon={require('src/Images/questionMark.png')}
        />
        <PrimaryButton
          background={global?.color?.gray3}
          handlePress={() => {
            challengeComplete
              ? navigationRef.goBack(null)
              : beginChallenge(
                  playerCount,
                  challengeMedium,
                  playerList,
                  groupInfo,
                );
          }}
          text={
            challengeComplete ? 'Return To Bar Challenges' : 'Begin Challenges'
          }
        />
      </FooterOverlay>
      <ModalSelector
        data={players}
        ref={selectorRef}
        onChange={(key) => {
          handleModalSelection(
            selectedBarChallenge,
            key.userId,
            key.parentUserId,
            key.label,
            key.photoUrl || null,
          );
        }}
        customSelector={<View />}
        overlayStyle={{justifyContent: 'flex-end'}}
        style={{position: 'absolute', left: 0, right: 0, width: 0}}
      />
    </SafeAreaView>
  );
};

const styles = StyleSheet.create({
  container: {
    backgroundColor: global?.color?.white,
    flex: 1,
  },
  section: {
    flex: 1,
  },
  winnerContainer: {
    alignItems: 'center',
    flexDirection: 'row',
    flexWrap: 'wrap',
    justifyContent: 'center',
    marginHorizontal: 20,
    marginTop: 10,
    width: 315,
  },
  footerButton: {
    alignItems: 'center',
    flex: 1,
    height: 60,
    justifyContent: 'center',
    marginVertical: 5,
  },
  winnerOpacity: {
    width: 95,
    height: 90,
    margin: 5,
    alignItems: 'center',
    justifyContent: 'center',
    marginBottom: 20,
  },
  winnerIconWrapper: {
    width: 95,
    height: 90,
    margin: 5,
    alignItems: 'center',
    justifyContent: 'center',
    marginBottom: 20,
  },
});

export default BarChallengeCompletionModal;
